<script setup lang="ts">
import { mockIRItems } from "~/assets/ts/announcementItems";

useSeoMeta({
	title: "電子公告｜株式会社Bang",
	description: "株式会社Bangの電子公告、決算公告を掲載しています。",

	// OGP設定
	ogTitle: "電子公告｜株式会社Bang",
	ogDescription: "株式会社Bangの電子公告、決算公告を掲載しています。",
	ogUrl: "https://www.bang-inc.jp/ir",
});

const navItems = [{ text: "トップページ", href: "/" }, { text: "電子公告" }];
</script>

<template>
    <main class="ir">
        <!-- パンくずリスト -->
        <Breadcrumbs :items="navItems" />
        <div class="ir-body">
            <HeadingCorp :level="1">電子公告</HeadingCorp>
            <HeadingCorp :level="2">法定公告</HeadingCorp>
            <p class="ir-text">
                当社は、決算公告のみ電子公告により開示しております。<br>
                なお、2021年3月期及び2022年3月期につきましては、官報にて掲載しております。<br>
                事故その他やむを得ない事由により電子公告をする事ができない場合には、官報に公告いたします。
            </p>
            <AnnouncementContainer :items="mockIRItems" />
        </div>
    </main>
</template>

<style scoped lang="scss">
.ir {
    position: relative;
    width: min(91vw, 64.5rem);
    margin: auto;

    &::before {
        content: '';
        position: absolute;
        width: 20rem; // 320px
        height: 20rem; // 320px
        aspect-ratio: 1/1;
        left: -4rem; // -64px
        top: -3rem; // -48px
        border-radius: 20rem; // 320px
        box-sizing: border-box;
        border: 1.5rem solid #EFF7FF; // 24px
        z-index: -1; // コンテンツの背景に配置
        pointer-events: none; // クリックイベントを通す
    }

    &-body {
        padding: 2rem 0 3rem 0;
    }

    &-text {
        width: 100%;
        color: #252522;
        font-size: 1rem;
        font-style: normal;
        font-weight: 400;
        line-height: 150%;
        padding-bottom: 1rem;
    }
}

// PC用のスタイル
@include mixin.media(pc) {
    .news {
        margin: 1rem auto auto;
    }

    .ir {
        &::before {
            width: 32.5rem; // 520px
            height: 32.5rem; // 520px
            left: -10.7rem; // -171.2px
            top: -4rem; // -64px
            border-radius: 32.5rem; // 520px
            border: 2.5rem solid #EFF7FF; // 24px
        }

        &-body {
            padding: 3.5rem 0 6rem 0;
        }

        &-text {
            padding-bottom: 3rem;
            border-bottom: 0.0625rem solid #E5E5E7;
        }
    }
}
</style>